/**
 * The stops of a trip on a rail — dot at the start, square at the end. Shared
 * by the day-screen hero (dark), the transfer card and the programme card
 * (light); the colour difference is handled in Portal.scss.
 *
 * `stops` is `[{ key, label?, time?, title, detail? }]`. A time column is
 * drawn when any stop has a time, so a programme's stops line up.
 */
import React from 'react';
import { ENDPOINT_WORDS, place } from '../portalFormat';

// The driver screens' words for the two ends; the operator screens pass
// their English ones (operatorFormat's ENDPOINT_LABELS_EN).
const ENDPOINT_LABELS = ENDPOINT_WORDS;

/**
 * Pickup and drop-off as rail stops, optionally labelled — "Felvétel" /
 * "Cél" unless `labels` names them otherwise.
 */
export const endpointStops = (trip, labelled = false, labels = ENDPOINT_LABELS) => [
  { key: 'from', label: labelled ? labels.from : '', ...place(trip.from) },
  { key: 'to', label: labelled ? labels.to : '', ...place(trip.to) },
];

export default function RouteRail({ stops }) {
  const timed = stops.some((stop) => stop.time);
  return (
    <span className="pp-route">
      <span className="pp-route__rail" aria-hidden="true">
        <span className="pp-route__dot" />
        <span className="pp-route__line" />
        <span className="pp-route__square" />
      </span>
      <span className="pp-route__stops">
        {stops.map((stop) => (
          <span className="pp-stop" key={stop.key}>
            {timed ? <span className="pp-stop__time">{stop.time}</span> : null}
            <span className="pp-stop__body">
              {stop.label ? <span className="pp-eyebrow">{stop.label}</span> : null}
              <span className="pp-route__title">{stop.title || '—'}</span>
              {stop.detail ? <span className="pp-route__detail">{stop.detail}</span> : null}
            </span>
          </span>
        ))}
      </span>
    </span>
  );
}
